import { 당진공장, 인천공장, 포항공장 } from "./options";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-select-field",
        label: "사업장명",
        value: "field",
        query: {"f_id": "fieldId", "f_name": "fieldName"},
        options: {
          default: {fieldId: "", fieldName: ""},
        }
      },
      {
        component: "search-select",
        label: "공장명",
        value: "공장명",
        query: {"ss_a1": "select"},
        options: {
          itemsSearchKeys: ['field.fieldName'],
          itemsJSON: { 당진공장, 인천공장, 포항공장 }
        }
      },
      {
        component: "search-select",
        label: "공정명",
        value: "공정명",
        query: {"ss_a2": "select"},
        options: {
          itemsSearchKeys: ['field.fieldName', '공장명'],
          itemsJSON: { 당진공장, 인천공장, 포항공장 }
        }
      },
      { component: 'empty-space' },
      {
        component: 'search-keyword',
        label: '제품명',
        value: '제품명',
        query: {'i_name': 'keyword'},
        options: {
          default: '',
        }
      },
      {
        component: 'search-keyword',
        label: '제조사',
        value: '제조사',
        query: {'i_maker': 'keyword'},
        options: {
          default: '',
        }
      },
      {
        component: 'search-keyword',
        label: '용도',
        value: '용도',
        query: {'i_pp': 'keyword'},
        options: {
          default: '',
        }
      },
      { component: 'empty-space' },
      {
        component: 'search-keyword',
        label: '구성성분',
        value: 'elements',
        query: {'el': 'keyword'},
        options: {
          default: '',
        }
      },
      { component: 'empty-space' },
      {
        component: 'search-check-group',
        label: '주요관리항목',
        value: 'mn_check',
        query: {'ck_l': 'checkList'},
        options: {
          list: [
            {text: '특별관리물질', value: '특별관리물질'},
            {text: '관리대상물질', value: '관리대상물질'},
            {text: '작업환경측정', value: '작업환경측정'},
            {text: '특수건강검진', value: '특수건강검진'},

            {text: '유독물질', value: '유독물질'},
            {text: '제한물질', value: '제한물질'},
            {text: '금지물질', value: '금지물질'},
            {text: '사고대비물질', value: '사고대비물질'},

          ],
          selectMaxCount: 8,
          default: [],
        }
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    if (search.field && search.field.fieldName) {
      conditions.push({
        key: "body.stdInfo.field_name",
        value: search.field.fieldName,
        operator: "=",
      });
    }

    if (search.공장명) {
      conditions.push({
        key: "body.공장명",
        value: search.공장명,
        operator: "IN",
      });
    }

    if (search.공정명) {
      conditions.push({
        key: "body.공정명",
        value: search.공정명,
        operator: "IN",
      });
    }

    if (search.제품명) {
      conditions.push({
        key: "body.제품명",
        value: `%${search.제품명}%`,
        operator: "LIKE",
      });
    }

    if (search.제조사) {
      conditions.push({
        key: "body.제조사",
        value: `%${search.제조사}%`,
        operator: "LIKE",
      });
    }

    if (search.용도) {
      conditions.push({
        key: "body.용도",
        value: `%${search.용도}%`,
        operator: "LIKE",
      });
    }


    if (search.elements) {
      const subConditions = []
      const elements = search.elements.split(',').map(e => e.trim());
      if (elements.length > 0) {
        for (const element of elements) {
          const firstCondition = {
            key: "body.구성성분[%].구성물질",
            value: `%${element}%`,
            operator: "LIKE",
          }
          if (subConditions.length > 0) {
            firstCondition.boolean = "OR";
          }
          subConditions.push(firstCondition)
          subConditions.push({
            key: "body.구성성분[%].CAS",
            value: `%${element}%`,
            operator: "LIKE",
            boolean: "OR",
          })
        }
      }

      conditions.push({
        boolean: "AND",
        conditions: subConditions,
      })
    }

    if (search.mn_check && search.mn_check.length > 0) {
      const subConditions = []
      for (const mnCheck of search.mn_check) {
        const sub = {
          key: `body.구성성분[%].${mnCheck}`,
          value: "1",
          operator: "IN",
        }
        if (subConditions.length > 0) {
          sub.boolean = "OR";
        }
        subConditions.push(sub)
      }

      conditions.push({
        boolean: "AND",
        conditions: subConditions,
      })
    }

    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "작성일",
        key: "created_at",
        pivot: true,
        style: { width: "100px", padding: '10px 5px' },
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
        pivot: true,
        style: { width: "90px", padding: '10px 5px' },
      },
      {
        name: "공장명",
        key: "body.공장명",
        pivot: true,
        textDisplay: "wrap",
        style: { width: "110px", padding: '10px 5px' },
      },
      {
        name: "공정명",
        key: "body.공정명",
        pivot: true,
        textDisplay: "wrap",
        style: { width: '110px', padding: '10px 5px' },
      },
      {
        name: "제품명",
        key: "제품명",
        pivot: true,
        /**
         * ellipsis : 기본값, 말줄임
         * wrap : 전체 표시
         * clip : 잘라내기
         */
        textDisplay: "wrap",
        style: { width: '150px', padding: '10px 5px' },
      },
      {
        name: "제조사",
        key: "",
        pivot: true,
        textDisplay: "wrap",
        style: { width: '100px', padding: '10px 5px' },
      },
      {
        name: "용도",
        key: "",
        pivot: true,
        textDisplay: "wrap",
        style: { width: '100px', padding: '10px 5px' },
      },
      {
        name: "구성성분",
        key: "",
        style: { minWidth: "400px", padding: '10px 5px' },
        textDisplay: "wrap",
        pivot: true,
      },
      // 주요관리항목 4종
      {
        name: "특별관리물질",
        key: "특별관리물질",
      },
      {
        name: "관리대상물질",
        key: "관리대상물질",
      },
      {
        name: "작업환경측정",
        key: "작업환경측정",
      },
      {
        name: "특수건강검진",
        key: "특수건강검진",
      },
      {
        name: "유독물질",
        key: "유독물질",
      },
      {
        name: "제한물질",
        key: "제한물질",
      },
      {
        name: "금지물질",
        key: "금지물질",
      },
      {
        name: "사고대비물질",
        key: "사고대비물질",
      },
      {
        name: "MSDS 등록번호",
        key: "body.msds등록번호",
      },
      {
        name: "첨부(MSDS)",
      },
      {
        name: "첨부(경고표지)",
      },
      {
        name: "첨부(교육날인부)",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: // 작성일
          return func.getCreatedDate(value.created_at)
        case 1: // 사업장명
          return func.getContent(value).stdInfo.field_name;
        case 2: // 공장명
          return func.getContent(value).공장명;
        case 3: // 공정명
          return func.getContent(value).공정명;
        case 4: // 제품명
          return func.getContent(value).제품명;
        case 5: // 제조사
          return func.getContent(value).제조사;
        case 6: // 용도
          return func.getContent(value).용도;
        case 7: // 구성성분
          const 구성성분 = func.getContent(value).구성성분;
          if (구성성분) {
            return {
              type: 'html',
              html: `<div style="text-align: left">${
                구성성분.map((item) => {
                  let text = `${item.구성물질} (CAS번호 ${item.CAS})`;
                  if (item.함량.범위 !== '없음') text += ` ... `;
                  if (item.함량.범위 === '고정값') text += `${item.함량.min}%`;
                  if (item.함량.범위 === '범위') text += `${item.함량.min}% ~ ${item.함량.max}%`;
                  return text;
                }).join("<br>")
              }</div>`
            };
          }
          return '';
        case 8: { // 특별관리물질
          const 구성성분 = func.getContent(value).구성성분;
          if (구성성분) {
            const filter = 구성성분.filter((e) => e.특별관리물질 === true);
            return {
              type: 'checkbox',
              value: filter.length > 0,
            }
          }
          return {
            type: 'checkbox',
            value: false,
          }
        }
        case 9: { // 관리대상물질
          const 구성성분 = func.getContent(value).구성성분;
          if (구성성분) {
            const filter = 구성성분.filter((e) => e.관리대상물질 === true);
            return {
              type: 'checkbox',
              value: filter.length > 0,
            }
          }
          return {
            type: 'checkbox',
            value: false,
          }
        }
        case 10: { // 작업환경측정
          const 구성성분 = func.getContent(value).구성성분;
          if (구성성분) {
            const filter = 구성성분.filter((e) => e.작업환경측정 === true);
            return {
              type: 'checkbox',
              value: filter.length > 0,
            }
          }
          return {
            type: 'checkbox',
            value: false,
          }
        }
        case 11: { // 특수건강검진
          const 구성성분 = func.getContent(value).구성성분;
          if (구성성분) {
            const filter = 구성성분.filter((e) => e.특수건강검진 === true);
            return {
              type: 'checkbox',
              value: filter.length > 0,
            }
          }
          return {
            type: 'checkbox',
            value: false,
          }
        }
        case 12: { // 유독물질
          const 구성성분 = func.getContent(value).구성성분;
          if (구성성분) {
            const filter = 구성성분.filter((e) => e.유독물질 === true);
            return {
              type: 'checkbox',
              value: filter.length > 0,
            }
          }
          return {
            type: 'checkbox',
            value: false,
          }
        }
        case 13: { // 제한물질
          const 구성성분 = func.getContent(value).구성성분;
          if (구성성분) {
            const filter = 구성성분.filter((e) => e.제한물질 === true);
            return {
              type: 'checkbox',
              value: filter.length > 0,
            }
          }
          return {
            type: 'checkbox',
            value: false,
          }
        }
        case 14: { // 금지물질
          const 구성성분 = func.getContent(value).구성성분;
          if (구성성분) {
            const filter = 구성성분.filter((e) => e.금지물질 === true);
            return {
              type: 'checkbox',
              value: filter.length > 0,
            }
          }
          return {
            type: 'checkbox',
            value: false,
          }
        }
        case 15: { // 사고대비물질
          const 구성성분 = func.getContent(value).구성성분;
          if (구성성분) {
            const filter = 구성성분.filter((e) => e.사고대비물질 === true);
            return {
              type: 'checkbox',
              value: filter.length > 0,
            }
          }
          return {
            type: 'checkbox',
            value: false,
          }
        }
        case 16: { // MSDS 등록번호
          return func.getContent(value).msds등록번호 || '-';
        }
        case 17: {
          const MSDS = func.getContent(value).MSDS || {};
          if (MSDS.path) {
            return {
              type: 'fileList',
              files: [MSDS],
            };
          }

          return '-';
        }
        case 18: {
          const 경고표지 = func.getContent(value).경고표지 || {};
          if (경고표지.path) {
            return {
              type: 'fileList',
              files: [경고표지],
            };
          }

          return '-';
        }
        case 19: {
          const 교육날인부 = func.getContent(value).교육날인부 || {};
          if (교육날인부.path) {
            return {
              type: 'fileList',
              files: [교육날인부],
            };
          }

          return '-';
        }
      }
    } catch (e) {
      console.log("e", e)
      /*ignore*/
    }
    return "";
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};

export default list;
